
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 195 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M195 87.826V11.41A11.27 11.27 0 00183.718.118H11.282A11.27 11.27 0 000 11.41v76.416a11.27 11.27 0 0011.282 11.292H183.718A11.27 11.27 0 00195 87.827zM28.442 93.761V5.475h141.37v88.286H28.442z","fill":"#691D29"}}),_c('path',{attrs:{"d":"M6.717 49.645c0 4.38 3.548 7.93 7.924 7.93s7.924-3.55 7.924-7.93-3.548-7.931-7.924-7.931c-4.377 0-7.924 3.55-7.924 7.93z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.335 51.483v-3.677a1.3 1.3 0 011.312-1.313h3.673a1.3 1.3 0 011.312 1.313v3.677a1.3 1.3 0 01-1.312 1.313h-3.673c-.683 0-1.312-.578-1.312-1.313z","stroke":"#691D29","stroke-width":".825","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M182.301 59.623a1.522 1.522 0 103.045.002 1.522 1.522 0 00-3.045-.002zM183.403 54.476V41.4c0-.21.157-.368.367-.368a.36.36 0 01.368.368v13.077a.36.36 0 01-.368.368c-.157 0-.367-.158-.367-.368z","fill":"#fff"}})])
          )
        }
      }
    